// test1680
(1680 && 0);
